import React, { useEffect, useState } from 'react'
import { getTimeLeftProposal } from '../../../../../utils/format-date-time-message.utils';
import ProposalPreviewRequestExtension from './proposal-preview-request-extension';

interface Props {
    expiryDate: string;
}

export default function ProposalPreviewRequestExtensionContainer({ expiryDate }: Props) {
    const [timeLeft, setTimeLeft] = useState(() =>
            getTimeLeftProposal(expiryDate)
        );
    
        useEffect(() => {
            const interval = setInterval(() => {
                setTimeLeft(getTimeLeftProposal(expiryDate));
            }, 1000);
    
            return () => clearInterval(interval);
        }, [expiryDate]);
    return (
        <ProposalPreviewRequestExtension timeLeft={timeLeft} />
    )
}
